// @flow

import React from 'react'
import { connect } from 'react-redux'
import { reset } from 'redux-form'
import { Map } from 'immutable'
import imgAstronautLogo from '../../images/logo-black.svg'
import UserRegisterWizardFormFirstPage from './users/UserRegisterWizardFormFirstPage'
import UserRegisterWizardFormSecondPage from './users/UserRegisterWizardFormSecondPage'
import UserRegisterWizardFormThirdPage from './users/UserRegisterWizardFormThirdPage'
import initializers from '../../dependencies/initializers'
import { usersAddNavigationPage } from '../../actions/users'
import { globalBlockingTransition } from '../../helpers/global'

type Props = {
	resetForm: Function,
	usersAddNavigationPage: Function,
	usersNavigationData: Map<string, any>
};

type State = {
	childrenComponent: ?Object,
	unblockTransition: Function,
	cachedUsersNavigationDataPage: string
};

class UserRegisterWizardFormContainer extends React.Component<Props, State> {
	constructor(props) {
		super(props)

		this.state = {
			childrenComponent: null,
			unblockTransition: () => {},
			cachedUsersNavigationDataPage: ''
		}
	}

	componentDidMount() {
		const {
			resetForm,
			usersAddNavigationPage
		} = this.props

		const titleElement: Object = document.getElementsByTagName('title')

		titleElement[0].text = 'Get 30 for 30, free of charge'

		const unblockTransition: Function = globalBlockingTransition(() => {
			resetForm('UserRegisterWizardForm')
			usersAddNavigationPage(1)

			return 'Data is not saved! Are you sure you want to leave?'
		})

		this.setState({unblockTransition})
	}

	componentWillUnmount() {
		this.state.unblockTransition()
	}

	static getDerivedStateFromProps(nextProps, prevState) {
		const {
			usersNavigationData,
			usersAddNavigationPage
		} = nextProps

		if (usersNavigationData.get('page') !== prevState.cachedUsersNavigationDataPage) {
			let page: number = usersNavigationData.get('page')

			const nextPage: Function = () => {
				usersAddNavigationPage(page + 1)
			}

			const previousPage: Function = () => {
				usersAddNavigationPage(page - 1)
			}

			switch(page) {
				case 1:
					return {
						cachedUsersNavigationDataPage: page,
						childrenComponent: <UserRegisterWizardFormFirstPage
							previousPage={previousPage}
							onSubmit={nextPage} />
					}
				case 2:
					return {
						cachedUsersNavigationDataPage: page,
						childrenComponent: <UserRegisterWizardFormSecondPage
							previousPage={previousPage} />
					}
				case 3:
					return {
						cachedUsersNavigationDataPage: page,
						childrenComponent: <UserRegisterWizardFormThirdPage />
					}
				default:
					return {
						cachedUsersNavigationDataPage: page,
						childrenComponent: <UserRegisterWizardFormFirstPage
							previousPage={previousPage}
							onSubmit={nextPage} />
					}
			}
		}

		return null
	}

	render() {
    return (
			<main>
				<section>
					<header>
						<nav className="navbar public-page">
							<div className="container">
								<div className="navbar-header">
									<a className="navbar-brand" href="/">
										<img src={imgAstronautLogo} alt="ASTRNT" />
									</a>
								</div>
							</div>
						</nav>
					</header>
				</section>
				<section className="full-page">
					<div className="full-page-body">
						<div className="container">
							<div className="row">
								<div className="col-sm-6 intro-signup">
									<h2 className="heading1 larger normal">Get 30 for 30, <br /> free of charge.</h2>
									<div className="heading2 normal m-b-36">
										Try Astronaut today! Here's what's included:
									</div>
									<ul className="list-plain list-plain--icon heading4">
										<li><i className="glyphicon glyphicon-ok"></i>30 candidate credits, valid for 30 days</li>
										<li><i className="glyphicon glyphicon-ok"></i>Unlimited jobs</li>
										<li><i className="glyphicon glyphicon-ok"></i>Unlimited questions</li>
										<li><i className="glyphicon glyphicon-ok"></i>Up to 5 team members</li>
										<li><i className="glyphicon glyphicon-ok"></i>Hassle-free recruitment</li>
									</ul>
									<div className="heading6 normal m-t-36">
										Already have an account? <a href={initializers.recruiter_host+'/auth/login'} className="underline">Login here</a>.
									</div>
								</div>
								<div className="col-sm-6">
									{this.state.childrenComponent}
								</div>
							</div>
						</div>
					</div>
				</section>
			</main>
    )
	}
}

const mapStateToProps = (state) => {
	return {
		usersNavigationData: state.usersNavigationData
	}
}

const mapDispatchToProps = (dispatch) => {
	return {
		resetForm: (formName) => dispatch(reset(formName)),
		usersAddNavigationPage: (page) => dispatch(usersAddNavigationPage(page))
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(UserRegisterWizardFormContainer)
